export default class Log {
	// TODO (Michael): Improve this. See what I did for Plaudit-analytics
	//		and my notes on this topic. Create a package and deploy to the public for this purpose.
	//		Should we wrap all methods on console which are not experimental or not widely supported?

	// TODO (Michael): The console is giving the line number for this file and not from what called this. How can we change that? Look at what loglevel does.

	static log(message?: any, ...optionalParams: any[]): void {
		console.log.apply(console, [message, ...optionalParams]);
	}
	static debug(message?: any, ...optionalParams: any[]): void {
		console.debug.apply(console, [message, ...optionalParams]);
	}
	static info(message?: any, ...optionalParams: any[]): void {
		console.info.apply(console, [message, ...optionalParams]);
	}
	static warn(message?: any, ...optionalParams: any[]): void {
		console.warn.apply(console, [message, ...optionalParams]);
	}
	static error(message?: any, ...optionalParams: any[]): void {
		console.error.apply(console, [message, ...optionalParams]);
	}

	static trace(message?: any, ...optionalParams: any[]): void {
		console.trace.apply(console, [message, ...optionalParams]);
	}

	static group(groupTitle?: string, ...optionalParams: any[]): void {
		console.group.apply(console, [groupTitle, ...optionalParams]);
	}
	static groupCollapsed(groupTitle?: string, ...optionalParams: any[]): void {
		console.groupCollapsed.apply(console, [groupTitle, ...optionalParams]);
	}
	static groupEnd(): void {
		console.groupEnd()
	}

	static clear(): void {
		console.clear();
	}
}